export default __webpack_public_path__ + "static/media/insppvServicesinsurance.0c425dee.svg";